import { QueryClient } from '@tanstack/react-query';

class QueryClientService {
	queryClient: QueryClient;

	constructor() {
		this.queryClient = new QueryClient();
	}

	public getQueryData(keys: string[]): any {
		return this.queryClient.getQueryData(keys);
	}
}

export default new QueryClientService();
